import React from 'react';
import { useParams } from 'react-router';

import { useGetVariantLinkoutsQuery } from '../../api/variantApi';
import AddReference from '../components/AddReference';
import CollapseHeaderForSections from '../components/CollapseHeaderForSections';
import CollapsePanel from '../components/CollapsePanel';
import DetailCard from '../components/DetailCard';
import ReferencesOverview from '../components/ReferencesOverview';
import { VARIANT_STAGE_TYPES } from '../constants/stages';

const ReferencesSection = () => {
  const params = useParams();
  // Read linkouts straight from the query hook's cache rather than a selector
  const { data: linkouts } = useGetVariantLinkoutsQuery(
    { variant_id: params.vid },
    { skip: !params.vid },
  );

  return (
    <DetailCard>
      <CollapsePanel
        title={
          <CollapseHeaderForSections title={'References: functional studies'} />
        }
        panelKey="references"
      >
        <AddReference stageType={VARIANT_STAGE_TYPES.MOLECULAR_IMPACT} />
        <div className="interpretation__intervar-link">
          {linkouts?.pubmed_url && (
            <a
              href={linkouts.pubmed_url}
              target="_blank"
              rel="noopener noreferrer"
              className="interpretation__intervar-link__anchor"
            >
              PubMed{' '}
            </a>
          )}
          {linkouts?.mastermind_url && (
            <a
              href={linkouts.mastermind_url}
              target="_blank"
              rel="noopener noreferrer"
              className="interpretation__intervar-link__anchor"
            >
              MM{' '}
            </a>
          )}
          {linkouts?.google_scholar_url && (
            <a
              href={linkouts.google_scholar_url}
              target="_blank"
              rel="noopener noreferrer"
              className="interpretation__intervar-link__anchor"
            >
              Scholar{' '}
            </a>
          )}
        </div>
        <ReferencesOverview
          variantId={params.vid}
          filterByType="functional study"
          stageType={VARIANT_STAGE_TYPES.MOLECULAR_IMPACT}
        />
      </CollapsePanel>
    </DetailCard>
  );
};

export default ReferencesSection;
